/* global dataLayer */
import { activityLoggerService } from './ActivityLoggerService';
import $ from 'jquery';

export default {
    init() {
        // Bind faq items
        $('.faq-accordion').on('click', function () {
            let isOpen = $(this).find('.show')[0];
            if (!isOpen) {
                let faqTitle = $(this).find('.card-title')[0].innerText.trim();
                activityLoggerService.logConfiguratorActivity({ 'ActivityCodeName': 'FAQOverview.ItemClick', 'ActivityTitle': `FAQ clicked '${faqTitle}'`, 'ActivityValue': `User opened FAQ '${faqTitle}'` });

                // Log Google Analytics
                dataLayer.push({
                    'event': 'FAQClick',
                    'detail': {
                        'ActivityCodeName': 'FAQClick',
                        'ActivityTitle': `FAQ items '${faqTitle}' opened`,
                        'ActivityValue': faqTitle
                    }
                });
            }
        });
    }
};



// WEBPACK FOOTER //
// ./CMS/scripts/modules/FAQActivityLogger.js